export const USER_SETTINGS_UPDATE_REQUEST = 'USER_SETTINGS_UPDATE_REQUEST';
export const USER_SETTINGS_UPDATE_SUCCESS = 'USER_SETTINGS_UPDATE_SUCCESS';
export const USER_SETTINGS_UPDATE_FAIL = 'USER_SETTINGS_UPDATE_FAIL';

//App setting constants
export const APP_SETTINGS_FETCH_REQUEST = 'APP_SETTINGS_FETCH_REQUEST';
export const APP_SETTINGS_FETCH_SUCCESS = 'APP_SETTINGS_FETCH_SUCCESS';
export const APP_SETTINGS_FETCH_FAIL = 'APP_SETTINGS_FETCH_FAIL';
